import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SettingsService } from "../settings.service";
import * as customBuildPlaceholders from "../../../assets/ck-editor-placeholders/ckeditor";
import { createCompanyForm } from "./company.build";

@Component({
  selector: "app-company-settings",
  templateUrl: "./company-settings.component.html",
  styleUrls: ["./company-settings.component.scss"],
})
export class CompanySettingsComponent implements OnInit {
  public Editor = customBuildPlaceholders;
  public Editor2 = customBuildPlaceholders;

  public ckeConfig = {
    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "bulletedList",
      "numberedList",
      "link",
    ],
  };
  public placeholderConfig = {
    placeholderProps: {
      types: [
        "company_name",
        "invoice_number",
        "payer_name",
        "total_price",
        "invoice_date",
        "invoice_payment_to",
        "account_nr",
        "interest",
      ],
    },
  };
  public placeholdersConfirmedEmailTitle = {
    placeholderProps: {
      types: ["company_name", "event_name"],
    },
  };
  public placeholdersConfirmedEmail = {
    placeholderProps: {
      types: [
        "first_name",
        "company_name",
        "event_name",
        "event_details",
        "event_participants",
      ],
    },
  };

  public formOptions: FormGroup = createCompanyForm();

  hideAPIKey: boolean = true;
  hideAPISignature: boolean = true;
  hideStripeAPIKey: boolean = true;
  hideFakturowniaAPIKey: boolean = true;
  subscriptionList: any = [];
  textSubscriptionDO = "";
  idCompany: number;
  isLoadingCompany: boolean = true;
  companyDetails: any = {};

  constructor(
    private settingsService: SettingsService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.idCompany = Number(this.route.snapshot.paramMap.get("id"));
  }

  ngOnInit(): void {
    this.isLoadingCompany = true;
    this.formOptions
      .get("activeTypePayment")
      .valueChanges.subscribe((value) => {
        if (value === "payu") {
          this.formOptions
            .get("payuClientId")
            .setValidators(Validators.required);
          this.formOptions
            .get("payuClientSecret")
            .setValidators(Validators.required);
          this.formOptions.get("stripeSecretKey").clearValidators();
          this.formOptions.get("stripeSecretKey").disable();
          this.formOptions.get("payuClientId").enable();
          this.formOptions.get("payuClientSecret").enable();
          this.formOptions.get("payuClientId").updateValueAndValidity();
          this.formOptions.get("payuClientSecret").updateValueAndValidity();
          this.formOptions.get("stripeSecretKey").updateValueAndValidity();
        } else {
          this.formOptions
            .get("stripeSecretKey")
            .setValidators(Validators.required);
          this.formOptions.get("payuClientId").clearValidators();
          this.formOptions.get("payuClientSecret").clearValidators();
          this.formOptions.get("stripeSecretKey").enable();
          this.formOptions.get("payuClientId").disable();
          this.formOptions.get("payuClientSecret").disable();
          this.formOptions.get("payuClientId").updateValueAndValidity();
          this.formOptions.get("payuClientSecret").updateValueAndValidity();
          this.formOptions.get("stripeSecretKey").updateValueAndValidity();
        }
      });
    if (this.idCompany > 0) {
      this.settingsService.getCompanyDetails(this.idCompany).subscribe(
        (resp) => {
          this.isLoadingCompany = false;
          this.subscriptionList = resp.subscriptionsHS;
          this.companyDetails = resp.companyDetails;
          this.formOptions.patchValue(this.companyDetails);
        },
        (err) => {
          console.error(err);
        }
      );
    } else {
      this.settingsService.getCompanyParams().subscribe(
        (resp) => {
          this.isLoadingCompany = false;
          console.log(resp);

          this.subscriptionList = resp;
        },
        (err) => {
          this.isLoadingCompany = false;
          console.error(err);
        }
      );
    }
  }
  addNewCompany() {
    if (this.formOptions.valid) {
      this.isLoadingCompany = true;
      this.settingsService.addNewCompany(this.formOptions.value).subscribe(
        (resp) => {
          this.isLoadingCompany = false;
          this.companyDetails = resp;
          this.router.navigate([
            "settings",
            this.companyDetails.id,
            "company-details",
          ]);
          this.toastr.success("Dodano nową firmę", "Success");
        },
        (err) => {
          console.error(err);
          this.isLoadingCompany = false;
          this.toastr.error("Błąd podczas dodawania nowej firmy", "Error");
        }
      );
    }
  }
  updateCompany() {
    if (this.formOptions.valid) {
      this.isLoadingCompany = true;
      this.settingsService
        .updateCompany(this.idCompany, this.formOptions.value)
        .subscribe(
          (resp) => {
            this.isLoadingCompany = false;
            this.companyDetails = resp;
            this.toastr.success("Zapisano zmiany", "Success");
          },
          (err) => {
            console.error(err);
            this.isLoadingCompany = false;
            this.toastr.error("Błąd podczas edycji danych firmy", "Error");
          }
        );
    }
  }
  removeCompany() {
    this.isLoadingCompany = true;
    this.settingsService.removeCompany(this.idCompany).subscribe((resp) => {
      this.isLoadingCompany = false;
      this.router.navigate(["settings"]);
      this.toastr.success("Usunięto firmę", "Success");
    });
  }
}
